import React from "react";
import "./SourceInfo.css";

export function SourceInfo({ url, title }) {
    if (!url) return null;
    return (
        <div className="source-info">
            <strong>Источник материала:</strong>{" "}
            <a target="_blank" href={url}>
                {title}
            </a>
        </div>
    );
}
